"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = require("../requests/request");
class API {
    /**
     * @returns {Promise<Contest>} The Promise contains either a result or an APIError if rejected
     */
    static get(path, query) {
        console.log('Gettting ' + path, query);
        let apiRequest = new request_1.AuthenticatedRequest('/bpm-analytics/' + path, request_1.HTTPMethod.GET, request_1.APIVersion.v3_0, query);
        return apiRequest.send().then((data) => {
            return data.data;
        });
    }
}
exports.API = API;
